import styled from "styled-components/macro";
import {
  HELP_DESKTOP_MEDIA,
  HELP_PANEL_WIDTH_PX,
  PROVIDER_SHELL_HEADER_Z_INDEX,
} from "../pages/Help/Help.constants";

export const ProviderAuthenticatedShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ProviderShellHeader = styled.div`
  flex: 0 0 auto;
  z-index: ${PROVIDER_SHELL_HEADER_Z_INDEX};
`;

export const ProviderShellBody = styled.div<{ $isHelpPanelOpen: boolean }>`
  min-width: 0;

  @media (${HELP_DESKTOP_MEDIA}) {
    display: grid;
    grid-template-columns:
      minmax(0, 1fr)
      ${({ $isHelpPanelOpen }) =>
        $isHelpPanelOpen ? `${HELP_PANEL_WIDTH_PX}px` : "0"};
    transition: grid-template-columns 320ms cubic-bezier(0.2, 0, 0, 1);

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`;

export const ProviderShellContent = styled.main`
  min-width: 0;
`;

export const ProviderShellHelpPanelSlot = styled.div<{
  $isHelpPanelOpen: boolean;
}>`
  min-width: 0;

  @media (${HELP_DESKTOP_MEDIA}) {
    align-self: stretch;
    background: ${({ $isHelpPanelOpen, theme }) =>
      $isHelpPanelOpen ? theme.white : "transparent"};
    border-left: ${({ $isHelpPanelOpen, theme }) =>
      $isHelpPanelOpen ? `1px solid ${theme.neutral200}` : "0"};
  }
`;
